
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registration-trademark-search",
      function () {
        return require("private-next-pages/registration-trademark-search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registration-trademark-search"])
      });
    }
  